// 在 src/services/api.js 或其他 API 文件中添加获取广告的方法
export const getFirstActiveAdvertisement = async () => {
  try {
    const response = await fetch('/api/advertisements/first-active');
    if (response.ok) {
      return await response.json();
    }
    return null;
  } catch (error) {
    console.error('获取广告失败:', error);
    return null;
  }
};

// 评论管理相关 API
export const getComments = async () => {
  const response = await fetch('/api/comments');
  if (!response.ok) {
    throw new Error('获取评论失败');
  }
  return await response.json();
};

export const getCommentById = async (commentId) => {
  const response = await fetch(`/api/comments/${commentId}`);
  if (!response.ok) {
    throw new Error('获取评论失败');
  }
  return await response.json();
};

export const createComment = async (commentData) => {
  const response = await fetch('/api/comments', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(commentData),
  });
  if (!response.ok) {
    throw new Error('创建评论失败');
  }
  return await response.json();
};

export const updateComment = async (commentId, commentData) => {
  const response = await fetch(`/api/comments/${commentId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(commentData),
  });
  if (!response.ok) {
    throw new Error('更新评论失败');
  }
  return await response.json();
};

export const deleteComment = async (commentId) => {
  const response = await fetch(`/api/comments/${commentId}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    throw new Error('删除评论失败');
  }
  return await response.json();
};